import { ModalBody, ModalFooter, TabPanel, TabPanels } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import SubmitButton from 'components/ui/SubmitButton';
import ListsCompanyView from 'features/emails/components/ListsCompanyView';
import ListsTagView from 'features/emails/components/ListsTagView';
import Lists from 'features/lists/components/Lists';
import { useMessages } from 'hooks/useMessages';
import { ArrayRequiredTestFunction } from 'lib/validation';
import { FormProvider, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useAgendaContext } from '../contexts/AgendaContext';
import { useSetListsToNoteTopic } from '../hooks/useSetListsToNoteTopic';

export interface Inputs {
  lists: [];
}

interface FormConnectNoteTopicToListsProps {
  topic: any;
}

const validationSchema = Yup.object().shape({
  lists: Yup.mixed().test('lists', '', ArrayRequiredTestFunction),
});

export default function FormConnectNoteTopicToLists({ topic }: FormConnectNoteTopicToListsProps) {
  const { onCloseConnectTopicToLists } = useAgendaContext();

  const defaultValues: Inputs = {
    lists: topic?.lists ? topic.lists.map(({ id } ) => id) : [],
  };

  const methods = useForm<Inputs>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as unknown as Resolver<Inputs>,
    defaultValues
  });

  const { handleSubmit, reset, formState: { isValid } } = methods;

  const { onError } = useMessages();

  const { onSetListsToNoteTopic, isPending } = useSetListsToNoteTopic({
    topic,
    onSuccess: () => {
      reset();
      onCloseConnectTopicToLists();
    },
    onError: (error) => onError(error?.response?.data?.message)
  });

  const onSubmit: SubmitHandler<Inputs> = (data) => onSetListsToNoteTopic(data);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody minH="400px">
          <Lists
            dir="column"
            searchParams={{
              contentGroupId: topic.note.contentGroupId
            }}
          >
            <TabPanels mt="60px" pb="90px">
              <TabPanel>
                <ListsCompanyView />
              </TabPanel>
              <TabPanel>
                <ListsTagView />
              </TabPanel>
            </TabPanels>
          </Lists>
        </ModalBody>  
        <ModalFooter>
          <SubmitButton 
            isDisabled={isPending || !isValid}
            isLoading={isPending}
            hideIcon
          >
            Associar
          </SubmitButton>
        </ModalFooter>
      </form>
    </FormProvider>
  )
}
